import { useState } from 'react';
import useDidMountEffect from '../../utils/hooks/effects/didMount';
import useFetch from '../../utils/hooks/useFetch';

function useFetchAirdrop(address: string) {
	const [hashAmount, setHashAmount] = useState('');
	let beforeAmount = 0;
	let afterAmount = 0;
	let campaignBonusAmount = 0;

	const {
		data: before,
		loading: loadingBefore,
		error: errorBefore,
	} = useFetch(`https://metabase.hashup.it/api/public/card/f10d99c1-ba46-43ff-bcb5-1cc1a63ac5b2/query?parameters=[{"type":"category","value":"${address}","target":["variable",["template-tag","userId"]]}]
`);

	const {
		data: after,
		loading: loadingAfter,
		error: errorAfter,
	} = useFetch(`https://metabase.hashup.it/api/public/card/1eca0a6a-d3ac-4295-acd8-f7a103549e37/query?parameters=[{"type":"category","value":"${address}","target":["variable",["template-tag","userId"]]}]
`);

	const campaignBonusQuery = useFetch(
		`https://metabase.hashup.it/api/public/card/1957e234-e564-40ec-9a20-852b7c09c337/query?parameters=[{"type":"category","value":"${address}","target":["variable",["template-tag","userId"]]}]`
	);

	if (before !== null && !loadingBefore && !errorBefore && before.status === 'completed') {
		try {
			beforeAmount = before.data.rows[0][0] / 1000000;
		} catch {}
	}
	if (after !== null && !loadingAfter && !errorAfter && after.status === 'completed') {
		try {
			afterAmount = after.data.rows[0][0] / 1000000;
		} catch {}
	}
	if (
		campaignBonusQuery.data !== null &&
		!campaignBonusQuery.loading &&
		!campaignBonusQuery.error &&
		campaignBonusQuery.data.status === 'completed'
	) {
		try {
			campaignBonusAmount = campaignBonusQuery.data.data.rows[0][0] / 1000000;
		} catch {}
	}

	useDidMountEffect(
		() => setHashAmount((beforeAmount * 50 + afterAmount * 20 + campaignBonusAmount * 20).toString()),
		[beforeAmount, afterAmount, campaignBonusAmount]
	);

	return hashAmount;
}

export default useFetchAirdrop;
